import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { contact } from 'contact/model/contact.fragments';
import { jobOffer } from 'job/model/job-offer.fragments';

import { ApiMutation } from '../../../../common/model/api.mutation';
import { tasksParticipant } from '../model/task.fragments';
import { TaskOutput } from '../model/task.output';

export interface CreateJobOfferMeetingInput {
	readonly dueTimestamp: number;
	readonly jobOfferId: string;
	readonly title: string;
}

export interface CreateJobOfferMeetingParams {
	input: CreateJobOfferMeetingInput;
}

@Injectable({ providedIn: 'root' })
export class CreateJobOfferMeetingApiMutation extends ApiMutation<
	TaskOutput,
	CreateJobOfferMeetingParams
> {
	client = 'iam';
	document = gql`
		mutation CreateJobOfferMeeting($input: CreateJobOfferMeetingInput!) {
			createJobOfferMeeting(input: $input) {
				id
				done
				type
				owner {
					id
				}
				contact {
					...Contact
				}
				jobOffer {
					...JobOffer
				}
				modulesId
				todoTitle
				dueTimestamp
				updateTimestamp
				participants {
					...TasksParticipant
				}
				todoDescription
			}
		}
		${tasksParticipant}
		${jobOffer}
		${contact}
	`;
	method = 'createJobOfferMeeting';
}
